(ns ballot-scout-v2-frontend.layout.header
  (:require [ballot-scout-v2-frontend.components.link :refer [link]]))

(defn logout-button []
  [link
   :ballot-scout-v2-frontend.routes/logout
   [:button {:class "button is-link"}
    "Log Out"]])

(defn logo []
  [:div {:class "level-item logo"}
   [:img {:src "/images/logo.svg"}]])

(defn header []
  [:div {:class "level header"}
   [:div {:class "level-left logo-container"}
    [:div {:class "level-item logo"}
     [:img {:src "/images/logo.svg"}]]]
   [:div {:class "level-right"}
    [:div {:class "level-item"}
     [logout-button]]]])
